import store from '@/store';
import { leaseType } from '@/util/dictList.js';
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  searchIndex: 7,
  searchLabelWidth: 100,
  column: [
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      search: true,
      searchOrder: 989,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 998,
    },
    {
      label: '手机号',
      prop: 'phoneNumber',
      type: 'input',
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
      search: true,
      searchOrder: 997,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      search: true,
      searchOrder: 1000,
      hide: true,
      filterable: true,
      searchMultiple: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '弃单状态',
      prop: 'breakType',
      type: 'select',
      search: false,
      searchOrder: 984,
      hide: true,
      // filterable: true,
      // searchMultiple: true,
      dicData: [
        {
          label: '确认收购价弃单',
          value: 1,
        },
        {
          label: '确认租赁额度弃单',
          value: 2,
        },
        {
          label: '特批车弃单',
          value: 3,
        },
        {
          label: '特批人弃单',
          value: 4,
        },
        {
          label: '总经理弃单',
          value: 5,
        },
        {
          label: '超时未进件',
          value: 6,
        },
        {
          label: '超时放弃进件',
          value: 7,
        },
        {
          label: '集团财务弃单',
          value: 8,
        },
      ],
      // props: {
      //   label: 'title',
      //   value: 'id',
      // },
    },
    {
      label: '所属代理商',
      prop: 'deptName',
      type: 'input',
      width: 90,
    },
    {
      label: '代理商类型',
      prop: 'agentType',
      type: 'select',
      search: false,
      width: 90,
      dicData: [
        {
          label: '直管',
          value: 1,
        },
        {
          label: '代管',
          value: 2,
        },
      ],
    },
    {
      label: '是否重复',
      prop: 'isRepeat',
      type: 'select',
      search: true,
      searchOrder: 995,
      dicData: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 2,
        },
      ],
    },
    {
      label: '是否特批',
      prop: 'isSpecial',
      type: 'select',
      search: true,
      searchOrder: 993,
      dicData: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 2,
        },
      ],
    },
    {
      label: '是否省代',
      prop: 'provincialRepresentative',
      type: 'select',
      search: true,
      hide: true,
      searchOrder: 994,
      dicData: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
    },
    {
      label: '是否省代',
      prop: 'provincialRepresentativeName',
      type: 'select',
    },
    // {
    //   label: '代管比例',
    //   prop: 'manageProportion',
    //   type: 'input',
    //   formatter: (val, value) => {
    //     return value ? value : '-';
    //   },
    // },
    {
      label: '平台',
      prop: 'platformName',
      type: 'select',
      width: 50,
      dicData: [
        {
          label: '若磐',
          value: 0,
        },
        {
          label: '程力',
          value: 1,
        },
        {
          label: '楚钧',
          value: 4,
        },
        {
          label: '品融',
          value: 5,
        },
      ],
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      dicData: store.getters.porductTypes,
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'cascader',
      dicData: store.getters.porductCascader,
      searchCheckStrictly:true,
      // searchMultiple: true,
      hide: true,
      search: true,
      searchOrder: 999,
      cascader: ['lendingRate'],
    },
    {
      label: '租率',
      prop: 'lendingRate',
      type: 'select',
      formatter: (val, value) => {
        return value ? value + '%' : '-';
      },
    },
    // {
    //   label: '租率',
    //   prop: 'rate',
    //   type: 'select',
    //   hide: true,
    //   search: true,
    //   searchOrder: 990,
    //   dicData: [],
    //   props: {
    //     label: 'lable',
    //     value: 'rate',
    //   },
    // },
    {
      label: '租期',
      prop: 'tenancy',
      type: 'select',
      formatter: (val, value) => {
        return value ? value + '期' : '-';
      },
      dicData: leaseType,
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'input',
      formatter: (val, value) => {
        return value ? value : '-';
      },
    },
    // {
    //   label: '租赁金额',
    //   prop: 'lendingAmountRange',
    //   type: 'input',
    //   searchOrder: 991,
    //   search: true,
    //   hide: true,
    // },
    {
      label: '结清日期',
      prop: 'settlementTerminationDate',
      type: 'daterange',
      searchRange: true,
      dataType: 'string',
      valueFormat: 'yyyy-MM-dd',
      search: false,
      hide: true,
    },
    {
      label: '起租日',
      prop: 'commencementDate',
      type: 'date',
      valueFormat: 'yyyy-MM-dd',
    },
    {
      label: '每期租金',
      prop: 'lendingAmountper',
      type: 'input',
      formatter: (val, value) => {
        return value ? value : '-';
      },
    },
    {
      label: '起租日',
      prop: 'commencementDateRange',
      type: 'daterange',
      search: true,
      searchRange: true,
      dataType: 'string',
      hide: true,
      valueFormat: 'yyyy-MM-dd',
      searchOrder: 992,
      searchTip: '最多支持60天的区间查询',
      searchTipPlacement: 'top',
    },
    {
      label: '新增日期',
      prop: 'commitTimeRange',
      type: 'daterange',
      search: true,
      searchRange: true,
      dataType: 'string',
      hide: true,
      valueFormat: 'yyyy-MM-dd',
      searchOrder: 996,
    },
  ],
};

//客户档案
export const recordOption = [
  {
    label: '身份证',
    prop: 'carDealerCardNo',
    type: 'input',
  },
  {
    label: '租赁人属性',
    prop: 'tenantAttribute',
    type: 'input',
  },
  // {
  //   label: '型号',
  //   prop: 'carModel',
  //   type: 'input',
  // },
  // {
  //   label: '申请金额',
  //   prop: 'needAmount',
  //   type: 'input',
  //   formatter: (val, value) => {
  //     return value ? value : '-';
  //   },
  // },
  {
    label: '收购价',
    prop: 'groupAssessAmount',
    type: 'input',
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '租付类型',
    prop: 'loanBeforePayName',
    type: 'select',
  },
  // {
  //   label: '放款方式',
  //   prop: 'lendingType',
  //   type: 'input',
  // },
  // {
  //   label: '最后放款时间',
  //   prop: 'lendingTime',
  //   type: 'date',
  //   width: 120,
  //   valueFormat: 'yyyy-MM-dd',
  //   hide: false,
  // },
  // {
  //   label: '创建人',
  //   prop: 'createUserName',
  //   type: 'input',
  // },
  {
    label: '创建时间',
    prop: 'createTime',
    type: 'input',
  },
];

//存量客户
export const stockOption = [
  {
    label: '本期应还租日期',
    prop: 'lendingDate',
    type: 'date',
    valueFormat: 'yyyy-MM-dd',
  },
  {
    label: '租赁人期数',
    prop: 'rentPersionTenancy',
    type: 'select',
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '代理商期数',
    prop: 'agentCurrentTenancy',
    type: 'select',
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '当前逾期期数',
    prop: 'currentOverdueTenancy',
    type: 'select',
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '当前流程状态',
    prop: 'currentStatusString',
    type: 'select',
    width: 100,
    dicData: [
      {
        label: '待还款',
        value: 1,
      },
      {
        label: '入账中',
        value: 2,
      },
      {
        label: '驳回',
        value: 3,
      },
    ],
  },
  {
    label: '累计已还租金',
    prop: 'totalRepaidRent',
    type: 'input',
    width: 90,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '累计已还滞纳金',
    prop: 'totalRepaidLateFee',
    type: 'input',
    width: 90,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '累计代偿期数',
    prop: 'totalCompensationTenancy',
    type: 'input',
    width: 90,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '累计代偿租金',
    prop: 'totalCompensationRent',
    type: 'input',
    width: 90,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '累计代偿滞纳金',
    prop: 'totalCompensationLateFee',
    type: 'input',
    width: 90,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '保证金已抵扣金额',
    prop: 'securityDepositDeductionAmount',
    type: 'input',
    width: 120,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '剩余应还租金',
    prop: 'remainingRent',
    type: 'input',
    width: 90,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '剩余应还滞纳金',
    prop: 'unpaidLateFeeTotal',
    type: 'input',
    width: 90,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  {
    label: '上期实际还租日期',
    prop: 'practicalLendingDate',
    type: 'input',
    width: 90,
    formatter: (val, value) => {
      return value ? value : '-';
    },
  },
  // {
  //   label: '当前移交部门',
  //   prop: 'currentDeptName',
  //   type: 'select',
  //   width: 100,
  // },
  // {
  //   label: '拖车状态',
  //   prop: 'carStatusName',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '谈判状态',
  //   prop: 'negotiateTypeName',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '诉讼状态',
  //   prop: 'lawsuitStatusName',
  //   type: 'input',
  //   width: 90,
  // },
];

//结清客户
export const settleOption = [
  {
    label: '租付类型',
    prop: 'loanBeforePayName',
    type: 'select',
  },
  // {
  //   label: '放款方式',
  //   prop: 'lendingType',
  //   type: 'input',
  // },
  // {
  //   label: '申请金额',
  //   prop: 'needAmount',
  //   type: 'input',
  // },
  {
    label: '收购价',
    prop: 'groupAssessAmount',
    type: 'input',
  },
  // {
  //   label: '已结清租金',
  //   prop: 'settlementRentAmount',
  //   type: 'input',
  // },
  // {
  //   label: '已结清违约金',
  //   prop: 'settlementLiquidatedDamagesAmount',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '已还滞纳金',
  //   prop: 'hadRepaymentOverdueFine',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '已付劳务费',
  //   prop: 'serviceFeeAmount',
  //   type: 'input',
  //   width: 90,
  // },
  // {
  //   label: '是否抵扣',
  //   prop: 'deductionStatus',
  //   type: 'select',
  //   dicData: [
  //     {
  //       label: '是',
  //       value: 1,
  //     },
  //     {
  //       label: '否',
  //       value: 0,
  //     },
  //   ],
  // },
  // {
  //   label: '保证金已抵扣金额',
  //   prop: 'securityDepositDeductionAmount',
  //   type: 'input',
  //   width: 120,
  // },
  {
    label: '结清日期',
    prop: 'settlementTerminationDate',
    type: 'daterange',
    searchRange: true,
    dataType: 'string',
    valueFormat: 'yyyy-MM-dd',
  },
  {
    label: '结清方式',
    prop: 'settlementTerminationSourceName',
    type: 'select',
  },
  // {
  //   label: '车辆处理状态',
  //   prop: 'carStatusName',
  //   type: 'select',
  //   width: 100,
  // },
  // {
  //   label: '创建人',
  //   prop: 'createUserName',
  //   type: 'input',
  // },
  {
    label: '创建时间',
    prop: 'createTime',
    type: 'input',
  },
];

//弃单客户
export const abandonOption = [
  {
    label: '身份证',
    prop: 'carDealerCardNo',
    type: 'input',
  },
  // {
  //   label: '申请金额',
  //   prop: 'needAmount',
  //   type: 'input',
  //   formatter: (val, value) => {
  //     return value ? value : '-';
  //   },
  // },
  // {
  //   label: '最后放款时间',
  //   prop: 'lendingTime',
  //   type: 'date',
  //   width: 120,
  //   valueFormat: 'yyyy-MM-dd',
  //   hide: false,
  // },
  {
    label: '弃单人',
    prop: 'breakPerson',
    type: 'input',
    addDisplay: false,
    editDisplay: false,
    viewDisplay: false,
    search: false,
  },
  {
    label: '弃单状态',
    prop: 'breakName',
    type: 'select',
    addDisplay: false,
    editDisplay: false,
    viewDisplay: false,
    search: false,
  },
];

//根据角色权限来展示
export const jurisdictionDifferentiate = {
  finance: [
    {
      title: '租赁人',
      value: 'name',
      order: 1,
    },
    {
      title: '车牌号',
      value: 'carFirstNumber',
      order: 2,
    },
    {
      title: '所属代理商',
      value: 'deptName',
      order: 3,
    },
    {
      title: '产品类型',
      value: 'rentType',
      order: 4,
    },
    {
      title: '租率',
      value: 'lendingRate',
      order: 5,
    },
    {
      title: '租期',
      value: 'tenancy',
      order: 6,
    },
    {
      title: '租赁金额',
      value: 'lendingAmount',
      order: 7,
    },
    {
      title: '起租日',
      value: 'commencementDate',
      order: 8,
    },
    {
      title: '每期租金',
      value: 'lendingAmountper',
      order: 9,
    },
    {
      title: '租付类型',
      value: 'loanBeforePayName',
      order: 10,
    },
  ],
};
